import AppConfig from './appConfig.js';
import ConfigAdaptor from './configAdapter.js';

export var configManager = (function() {
    var DEFAULT_CONFIG_URI = '/content/configuration/global';
    var appConfig = AppConfig;
    var config = {};
    var lastUrl = '';

    var setConfig = function(configObj) {
        config = configObj;
    };

    var setAppConfig = function(configObj) {
        appConfig = configObj;
    };

    var getConfig = function() {
        return config;
    };

    var getAppConfig = function() {
        return appConfig;
    };

    var clearConfig = function() {
        config = {};
        lastUrl = '';
    };

    var getUrlConfig = function(url, clearIt) {
        if (clearIt) {
            clearConfig();
        }

        return getConfiguration(url);
    };

    var replaceSubstitutionWithConfig = function(strings) {
        var configsArray = strings.match(/{\w+}/g);
        configsArray = [...new Set(configsArray)];
        if (configsArray.length > 0) {
            configsArray.forEach(function(element) {
                var configToFind = element.replace(/[{}]/g, '');
                var configValue = config.site[configToFind];
                var elementPattern = new RegExp(element, 'g');
                strings = strings.replace(elementPattern, configValue);
            });
        }
        return strings;
    };

    // Url looks something like: "https://test.mynuskin.com/content/configuration/global/mec.service.US.json". The url
    // will only be used if it is on the meCommerce system.
    var getConfiguration = function(url) {
        // If we are on the legacy system, convert legacy configuration to mecommerce configuration format.
        if (nuskin && nuskin.configuration) {
            config = ConfigAdaptor(nuskin.configuration);
        } else {
            // Get the mecommerce configuration.
            /**
             * If this function is called again with the same url, it will just return the same configuration it loaded
             * previously. So in general, the ajax call will happen again if you change environments or countries.
             */
            if (url !== lastUrl) {
                $.ajax({
                    type: 'GET',
                    url: url,
                    dataType: 'json',
                    async: false,
                    success: function(data) {
                        config = data;
                        lastUrl = url;
                    },
                    error: function(xhr) {
                        config = {error: 'Ajax error in getting configuration: ' + url};
                        // eslint-disable-next-line no-console
                        console.log('could not load market configuration! error:' + xhr);
                        // eslint-disable-next-line no-console
                        console.log('Configuration URL: ' + url);
                    }
                });
            }
        }

        return config;
    };

    /**
     * Gets site configs
     * @param {String} siteType
     * @param {String} countryCode
     * @param {String} clearIt
     */
    var getSiteConfig = function(siteType, countryCode, clearIt) {
        if (clearIt) {
            clearConfig();
        }

        // baseUrl contains the protocol, host, and port
        var baseUrl;

        // Try to get the domain from the appConfig
        if (appConfig && appConfig.domain) {
            baseUrl = appConfig.domain;
        } else {
            // Else get the domain from the current browser url.
            var arr = window.location.href.split('/');
            baseUrl = arr[0] + '//' + arr[2];
        }

        var configUri = DEFAULT_CONFIG_URI + '/' + siteType;
        var configUrl = baseUrl + configUri + '.service.' + countryCode + '.json';

        // Examples for the configUrl:
        // http://someSite/content/configuration/global/markets.service.US.json
        // http://someSite/content/configuration/global/ltos.service.US.json
        // http://someSite/content/configuration/global/microsites/ageloc.service.US.json
        getConfiguration(configUrl);
    };

    // public functions exposing outside
    return {
        getConfig: getConfig,
        setConfig: setConfig,
        getAppConfig: getAppConfig,
        setAppConfig: setAppConfig,
        getUrlConfig: getUrlConfig,
        getSiteConfig: getSiteConfig,
        replaceSubstitutionWithConfig: replaceSubstitutionWithConfig
    };
})();




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/config-manager/config-manager.js
// module id = 2
// module chunks = 0